import Upload from './Upload';

const UploadPage = ({ isAdmin, viewAs }) => {
  // if (!isAdmin) {
  //   return (
  //     <div>
  //       <h1>Access denied</h1>
  //       <p>You do not have permission to access this page.</p>
  //     </div>
  //   );
  // }

  return <Upload viewAs={viewAs} />;
};

export default UploadPage;
